var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61998 13.0467C9.49331 13.0467 9.36664 13 9.26664 12.9C9.07331 12.7067 9.07331 12.3867 9.26664 12.1934L12.96 8.50002L9.26664 4.80668C9.07331 4.61335 9.07331 4.29335 9.26664 4.10002C9.45998 3.90668 9.77998 3.90668 9.97331 4.10002L14.02 8.14668C14.2133 8.34002 14.2133 8.66002 14.02 8.85335L9.97331 12.9C9.87331 13 9.74664 13.0467 9.61998 13.0467Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5533 9H2.33331C2.05998 9 1.83331 8.77333 1.83331 8.5C1.83331 8.22667 2.05998 8 2.33331 8H13.5533C13.8266 8 14.0533 8.22667 14.0533 8.5C14.0533 8.77333 13.8266 9 13.5533 9Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c8148aa86bfddb934258b28f2ca3af5a.svg";
export { ForwardRef as ReactComponent };